import React from 'react';
import Section from './Section';

function LeadershipAndExperience() {
  return (
    <Section title="Relevant Experience">
      <div>
        <h3>
          <a href="https://oit.caes.uga.edu/" target="_blank" rel="noopener noreferrer">
            UGA College of Agriculture and Environmental Sciences
          </a>
        </h3>
        <p>Information Technology Support Specialist, Athens, GA | August 2024 - Present</p>
      </div>
      <div>
        <h3>
          <a href="https://na.panasonic.com/" target="_blank" rel="noopener noreferrer">
            Panasonic North America
          </a>
        </h3>
        <p>IT Internal Audit Intern, Remote | May 2025 – October 2025</p>
      </div>
      <div>
        <h3>
          <a href="https://computing.uga.edu/" target="_blank" rel="noopener noreferrer">
            UGA School of Computing
          </a>
        </h3>
        <p>Undergraduate Research Assistant, Athens, GA | January 2024 - December 2024</p>
      </div>
      <div>
        <h3>
          <a href="https://sepiainnovations.com/" target="_blank" rel="noopener noreferrer">
            Sepia Innovations
          </a>
        </h3>
        <p>Software Engineer Intern, Shinjuku, Tokyo, Japan | June 2024 - August 2024</p>
      </div>
    </Section>
  );
}

export default LeadershipAndExperience;